/**
 * TanStack Query hooks for `campaign-level-restricted-countries`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	campaignLevelRestrictedCountriesQueryKeys,
	type CreateCampaignLevelRestrictedCountriesBody,
	type ListCampaignLevelRestrictedCountriesResponse,
	type CampaignLevelRestrictedCountriesRow,
} from "./api";

export function useCampaignLevelRestrictedCountriesList(): UseQueryResult<ListCampaignLevelRestrictedCountriesResponse, Error> {
	return useQuery({
		queryKey: campaignLevelRestrictedCountriesQueryKeys.list(),
		queryFn: list,
	});
}

export function useCampaignLevelRestrictedCountriesCreate(): UseMutationResult<CampaignLevelRestrictedCountriesRow, Error, CreateCampaignLevelRestrictedCountriesBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: campaignLevelRestrictedCountriesQueryKeys.all });
		},
	});
}

export function useCampaignLevelRestrictedCountriesDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: campaignLevelRestrictedCountriesQueryKeys.all });
		},
	});
}
